module.exports = __webpack_public_path__ + "static/media/starIcon2.cf7e4018.svg";